import { z } from 'zod';

export const passwordLongEnough = z
  .string()
  .min(7, 'PASSWORD_MIN_LENGTH')
  .describe('PASSWORD_MIN_LENGTH');
export const passwordHasUpperCase = z
  .string()
  .regex(/[A-Z]/, 'PASSWORD_INCLUDE_UPPERCASE')
  .describe('PASSWORD_INCLUDE_UPPERCASE');
export const passwordHasNumeric = z
  .string()
  .regex(/\d/, 'PASSWORD_INCLUDE_NUMERIC')
  .describe('PASSWORD_INCLUDE_NUMERIC');

export const passwordIsValid = passwordLongEnough
  .and(passwordHasNumeric)
  .and(passwordHasUpperCase);
